import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
} from '@material-ui/core';

import {
  Search as SearchIcon,
} from 'react-feather';

import { SIREN_CONFIG } from 'config.js';

import { connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateQueryPatientName, updateQueryPatientRoomName } from 'actions/query';
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";



const PatientTable = props => {
  const { className, users, queryPatientParams, ...rest } = props;
  const {formatMessage} = useIntl();

  const classes = useStyles();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);

  const [patientName, setPatientName] = useState('');
  const [patientRoomName, setPatientRoomName] = useState('');
  const facility_id = useSelector((store) => store.user.facility_id);

  const searchData = (patientName, patientRoomName) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/patient/patientList?facility_id=${facility_id}&`;

    var params = '';
    if (patientName){
      params += 'patientName='+patientName;
    }

    if (patientRoomName){
      params += params.length > 0 ? '&' : '';
      params += 'patientRoomName='+patientRoomName;
    }

    url += params;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {
      var list  = [];
      if( snapshot.resultData != null){
        snapshot.resultData.forEach( doc => {
          list.push(doc);
        });
      }
      setListData( list );
    }
    );
  }


  useEffect( () => {
    if ( queryPatientParams.patientName !== '' || queryPatientParams.patientRoomName !== ''){
      searchData(queryPatientParams.patientName, queryPatientParams.patientRoomName);
    }

    setPatientName(queryPatientParams.patientName);
    setPatientRoomName(queryPatientParams.patientRoomName);

    return () => {};
  }, []);



  const handleSearch = event => {
    searchData(patientName, patientRoomName);
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    props.updateQueryPatientName('');
    props.updateQueryPatientRoomName('');

    setPatientName('');
    setPatientRoomName('');
  }


  const handlePatientName = (event) => {
    event.persist();
    props.updateQueryPatientName(event.target.value);
    setPatientName(event.target.value);
  }

  const handlePatientRoomName = (event) => {
    event.persist();
    props.updateQueryPatientRoomName(event.target.value);
    setPatientRoomName(event.target.value);
  }

  const keyUp = (event) => {
    if (event.key === "Enter"){
      handleSearch();
      event.preventDefault();
    }
  }


  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };


  const startRow = (page*rowsPerPage);


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

    <Box m={1} p={2}>

    <Box mt={2}
      display="flex"
      alignItems="center"
      justifyContent="start"
      flexGrow={1}>

        <TextField className={classes.queryField}
          InputProps={{startAdornment: (
            <InputAdornment position="start">
              <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
            </InputAdornment>
          )}}

          onChange={handlePatientName}
          label={formatMessage({id:'patient_name'})}
          placeholder={formatMessage({id:'patient_name'})}
          value={patientName}
          variant="outlined"
          onKeyUp={keyUp}
        />

        <TextField className={classes.queryField}
          InputProps={{startAdornment: (
            <InputAdornment position="start">
              <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
            </InputAdornment>
          )}}

          onChange={handlePatientRoomName}
          label={formatMessage({id:'patient_room'})}
          placeholder={formatMessage({id:'patient_room'})}
          value={patientRoomName}
          variant="outlined"
          onKeyUp={keyUp}
        />

        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.bulkAction}
          onClick={handleSearch}

          >
          <FormattedMessage id="search" />
          </Button>


          <Button
          variant="outlined"
          size="large"
          className={classes.bulkAction}
          onClick={handleClear}
          >
          <FormattedMessage id="initialize" />
          </Button>

    </Box>
  </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_name" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_room" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_tel" /></TableCell>
                  <TableCell width="30%" align="center"><FormattedMessage id="patient_addr" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_caregiver" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_caregiver_tel" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_protector_name" /></TableCell>
                  <TableCell width="10%" align="center"><FormattedMessage id="patient_protector_tel" /></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.id}
                    component={RouterLink} to={`/patients/update/${module.patientId}`}
                    >

                    <TableCell width="10%" align="center">
                        <Typography variant="body1">{module.patientName}</Typography>
                    </TableCell>
                    <TableCell width="10%" align="center">{module.roomName}</TableCell>
                    <TableCell width="10%" align="center">{module.patientTelNo}</TableCell>
                    <TableCell width="30%" align="center">
                        <Typography variant="body2">{module.patientAddr1} {module.patientAddr2}</Typography>
                    </TableCell>
                    <TableCell width="10%" align="center">{module.caregiverName}</TableCell>
                    <TableCell width="10%" align="center">{module.caregiverTelNo}</TableCell>
                    <TableCell width="10%" align="center">{module.protector1_name}</TableCell>
                    <TableCell width="10%" align="center">{module.protector1_tel_no}</TableCell>

                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

PatientTable.propTypes = {
  className: PropTypes.string,
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateQueryPatientName,
    updateQueryPatientRoomName
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryPatientParams: state.queryPatientParams
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PatientTable));


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight:20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
